package navigation.home.organization

import navigation.home.organization.organizationdetails.OrganizationDetailsScreenModel
import org.koin.core.module.dsl.factoryOf
import org.koin.dsl.module

val OrganizationUiModule
    get() =
        module {
            factoryOf(::OrganizationScreenModel)
            factoryOf(::OrganizationDetailsScreenModel)
        }